module.exports = __webpack_public_path__ + "img/Redtea ready.0d2fc79b.png";